import React, { useEffect, useState } from 'react';
import { PATH_COMMON_BUTTON_ICON } from '../../../../constant/Common/Path/Asset/Icon/Button';
import { removeImageFileList } from '../../../../util/Safety/DamageReport/Handler/photoFileHandler';

const PhotoBox = ({
  index,
  setImageFileList,
  file,
  isCompleted,
  isEditable,
}) => {
  const [imageURL, setImageURL] = useState(null);

  useEffect(() => {
    if (file?.lastModified) {
      setImageURL(URL.createObjectURL(file));
    } else {
      setImageURL(file?.file_url);
    }
  }, [file]);

  return (
    <div className="flex flex-col gap-y-[4px]">
      <div className="flex flex-col items-center justify-center w-[60px] h-[60px] bg-[#F2F6FF] rounded-[5px]">
        {imageURL ? (
          <div
            className="w-full h-full hover:cursor-pointer"
            onClick={() => window.open(imageURL, '_blank')}
          >
            <img
              className="w-full h-full object-cover rounded-[5px]"
              src={imageURL}
              alt="damage"
            />
          </div>
        ) : (
          <span className="font-[500] text-[12px] text-[#556DA1] mt-[9px]">
            Photo
          </span>
        )}
      </div>
      <div className="flex justify-between items-center w-[60px] h-[12px] max-h-[12px] gap-x-[4px]">
        <div className="flex flex-1 items-center font-[300] text-[10px] text-[#595656] text-nowrap overflow-x-hidden overflow-y-hidden">
          {file?.name || file?.file_name}
        </div>
        {!isCompleted && isEditable && (
          <div
            className="w-[9px] h-[9px] hover:cursor-pointer"
            onClick={() =>
              removeImageFileList({
                setImageFileList,
                removeIdx: index,
              })
            }
          >
            <img
              src={PATH_COMMON_BUTTON_ICON?.crossRed?.default}
              alt="cancel"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default PhotoBox;
